function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import range from 'lodash/range';
import Chevron from 'svg/chevron-right.svg';
import styles from './Pages.pcss';
import Page from './Page';
var _React_PureComponent;
class Pages extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { activePage, totalPages, slotsNo, onChange } = this.props;
        let start = activePage - Math.ceil(slotsNo / 2) < 0 ? 0 : activePage - Math.ceil(slotsNo / 2);
        let end = activePage + Math.ceil(slotsNo / 2) > totalPages ? totalPages : activePage + Math.ceil(slotsNo / 2);
        if (start === 0) {
            const delta = Math.abs(activePage - Math.ceil(slotsNo / 2));
            end = end + delta > totalPages ? totalPages : end + delta;
        }
        if (end === totalPages) {
            const delta = Math.abs(totalPages - activePage - Math.ceil(slotsNo / 2));
            start = start - delta < 0 ? 0 : start - delta;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: styles.pages,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: "movePage movePage--previous",
                        onClick: ()=>onChange(activePage - 1),
                        disabled: !(totalPages > 1 && activePage > 0),
                        children: /*#__PURE__*/ _jsx(Chevron, {})
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.inner,
                        children: range(start, end).map((page)=>/*#__PURE__*/ _jsx(Page, {
                                active: page === activePage,
                                onClick: ()=>onChange(page),
                                children: page + 1
                            }, page))
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: "movePage movePage--next",
                        onClick: ()=>onChange(activePage + 1),
                        disabled: !(totalPages > 1 && activePage < totalPages - 1),
                        children: /*#__PURE__*/ _jsx(Chevron, {})
                    })
                ]
            })
        });
    }
}
_define_property(Pages, "propTypes", {
    // Explicit props
    totalPages: PropTypes.number,
    activePage: PropTypes.number.isRequired,
    slotsNo: PropTypes.number,
    // Explicit actions
    onChange: PropTypes.func
});
_define_property(Pages, "defaultProps", {
    slotsNo: 2
});
export default withStyles(styles)(Pages);
